import styled from 'styled-components';

export const TimeSeriesSelectorContainer = styled.div`
    height: 100%;
`;
